import React from "react";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import Contexto from "../context/Contexto";
import "../assets/css/Home.css";
import "../assets/css/Login.css";
import Registro from "../components/Registro";
import RegistroDos from "../components/RegistroDos";
import { useEffect } from "react";
function Home() {
  const { productos, seteos, usuario, cursoscomprados } = useContext(Contexto);
  const [uid, setUid] = useState(null);
  let username = false;
  useEffect(() => {
    console.log("algo cambio en usuario");
    if (usuario) {
      username = usuario.username;
      setUid(usuario.uid);
      console.log("soy:", usuario.uid);
    } else {
      setUid(null);
    }
    console.log("USUARIO:", cursoscomprados);
  }, [usuario]);
  return (
    <>
      <section className="home ">
        <React.Fragment>
          <div className="soporteLogin">
            <div className="login">
              <div className="login__wrapper">
                {!uid ? (
                  <React.Fragment>
                    <br />
                    <br />
                    <br />

                    <>
                      <Registro></Registro>
                    </>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {<p>Ya estás adentro :)</p>}
                    {cursoscomprados.proyectoweb ? (
                      <Link to="/miscursos" className="formuBT">
                        VER TUS PROGRAMAS
                      </Link>
                    ) : cursoscomprados.designseason7 ? (
                      <Link to="/ver/designseason7" className="formuBT">
                        VER DESIGNSEASON
                      </Link>
                    ) : cursoscomprados.designseason10 ? (
                      <Link to="/ver/designseason10" className="formuBT">
                        VER DESIGNSEASON
                      </Link>
                    ) : (
                      <a
                        href="https://www.colorclub.online/design-season"
                        className="formuBT"
                      >
                        COMPRAR PROGRAMA
                      </a>
                    )}
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </React.Fragment>
      </section>
    </>
  );
}

export default Home;
